import React from "react";
import "../scss/footer.scss";
import Button from "../components/Button";

const Footer = () => {
  return (
    <footer id="contact" className="myFooter">
      <h2>Contact</h2>
      <p>If you want to contact me, you can find me at:</p>
      <div className="social">
        <a href="https://github.com/khanchandanivikas" target="blank">
          <i className="fab fa-github"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/vikas-khanchandani-28414b138"
          target="blank"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>
        <a href="https://www.instagram.com/vikas_khh/" target="blank">
          <i className="fab fa-instagram"></i>
        </a>
      </div>
      <Button id="hireMe" link="mailto:khanchandani58@gmail.com">Hire me</Button>
    </footer>
  );
};

export default Footer;
